var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex w-100"},[_c('BarChart',{attrs:{"id":"my-chart-box-plot","data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }